export default __webpack_public_path__ + "static/media/ps_flower.45c30db6.png";